import { IBusinessType } from '@/models/business';

export type OperationTypeWithoutBoth = Exclude<
  IBusinessType,
  IBusinessType.BOTH
>;

export interface IEmptyRewardsProgramFeature {
  slug: string;
  name?: string;
  image?: string;
  chooseOperate?: OperationTypeWithoutBoth;
  background?: boolean;
  text?: string;
}

export const getFeaturesMapper = (
  businessType: string
): Record<string, IEmptyRewardsProgramFeature> => ({
  'offer-welcome-coins': {
    slug: 'welcomeCoins',
    name: 'Welcome Coins'
  },
  'settings-activation-emails': {
    slug: 'emailAutomation',
    name: 'Email Automation'
  },
  'customer-import': {
    slug: 'inviteCustomers',
    name: 'Invite Customers'
  },
  'social-rewards': {
    slug: 'socialRewards',
    name: 'Social Rewards'
  },
  'referral-program': {
    slug: 'referralProgram',
    name: 'Referral Program',
    text: 'Referrals'
  },
  'settings-widget': {
    slug: 'rewardsWidget',
    name: 'the Loyalty Widget',
    chooseOperate: IBusinessType.ONLINE
  },
  manage_loyalty: {
    slug: 'rewardsRate',
    image:
      businessType === IBusinessType.ONLINE
        ? '/npo/empty-rewards-program-online.png'
        : '/npo/empty-rewards-program.png'
  },
  refund_return_policy: {
    slug: 'refundPolice',
    image:
      businessType === IBusinessType.ONLINE
        ? '/npo/empty-rewards-program-online.png'
        : '/npo/empty-rewards-program.png'
  },
  'program-status': {
    slug: 'programStatus',
    image:
      businessType === IBusinessType.ONLINE
        ? '/npo/empty-rewards-program-online.png'
        : '/npo/empty-rewards-program.png'
  }
});
